import React from "react";
import { Link } from "react-router-dom";

const SidebarItem = ({ icon, text, link, collapsed }) => {
    return (
        <Link
            to={link}
            className={`
                flex items-center px-2 py-2 rounded-lg transition-colors
                ${collapsed ? "justify-center" : "gap-3"}
                hover:bg-teal-600
            `}
        >
            {icon}
            {!collapsed && <span>{text}</span>}
        </Link>
    );
};

export default SidebarItem;